<template>
    <el-dialog width="800px" title="新建采购" :before-close="handleClickCancel" class="custom-height-dialog" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="purchaseAddVisible" :modal-append-to-body="false">
        <div class="detail" v-loading="loading">
            <CustomFormPc v-if="formInfoList.length"
                          :field_list="formInfoList"
                          ref="purchaseForm"
                          :field_form="'purchases'"
                          @submit-form="submitPurchaseFormData"
                          @send-form-data="sendFormData" />

            <div class="add_approval_select_process">

                <approveProcessSelect ref="approveProcessSelectRef" :approval_node_list="approval_node_list"></approveProcessSelect>
            </div>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {getFormFields,getApprovalNodes,PurchaseAdd} from '@/api'
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
export default {
    name: 'purchase_add',
    components: {
        CustomFormPc,
        approveProcessSelect
    },
    props: {
        purchaseAddVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            formInfoList: [],
            purchaseFormData: {},

            approval_node_list:[]
        }
    },
    created() {
        this._getFromFields()
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        // 获取审批的字段
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'purchases'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    this.getApprovalNodes()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 获取审批流
        getApprovalNodes(only = false){
            this.approval_node_list = []
            getApprovalNodes({
                approval_type: 'purchase',
            }).then(res => {
                if (res.code === 200) {
                    this.approval_node_list = res.data
                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 表单提交
        submitPurchaseFormData(customForm){
            if (customForm) {
                let flag = false
                customForm.purchase_details.forEach((item,index)=>{
                    if(!item.product_name || !item.num){
                        flag = true
                    }
                })
                if(flag){
                    this.$message.error('请把采购明细填写完整')
                    return false
                }

                if(this.$refs.approveProcessSelectRef.handleClickPublish() == false){  //审批节点校验没通过
                    return false
                }
                // 预付款金额 ==  0或不填写时为全款支付
                if(customForm && customForm.prepayment_price.value == '' || customForm.prepayment_price.value == 0){
                    this.$set(customForm.prepayment_price,'text',customForm.pay_total_price.text)
                    this.$set(customForm.prepayment_price,'value',customForm.pay_total_price.value)
                }
                if(customForm && customForm.pre_due_date && customForm.pre_due_date.value == ''){
                    this.$set(customForm.pre_due_date,'value',null)
                }
                this.BtnDisabled = true;
                customForm.node_list = this.approval_node_list
                PurchaseAdd(customForm).then(res => {
                    if (res.code === 200) {
                        this.$message.success(res.message)
                        this.$emit('success')
                        this.$emit('update:purchaseAddVisible', false)
                    } else {
                        this.BtnDisabled = false;
                        this.$message.error(res.message)
                    }
                }).catch(() => {
                    this.BtnDisabled = false;
                })

            }
        },
        // 表单编辑了
        sendFormData(data){
            this.purchaseFormData = JSON.parse(JSON.stringify(data))
        },
        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:purchaseAddVisible', false)
        },
        handleClickConfirm(){
            this.$refs.purchaseForm.handleClickPublish();
        },

    },

}
</script>
<style lang="scss" scoped>

</style>
